<template>
  <div v-if="localizedLinks.length">
    <h3>{{ title }}</h3>
    <div :class="$style.seoLinks">
      <span v-for="link in localizedLinks" :key="link.url" :class="$style.linkWrapper">
        <a :href="link.url" :class="$style.seolink">
          <span>
            {{ link.name }}
          </span>
        </a>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { type Locale, type LocalizedUrls } from '@/stores/useGeoStore';

const { locale } = useI18n();
const props = defineProps<{
  title: string;
  links: Record<Locale, LocalizedUrls> | null;
}>();

const localizedLinks = computed(
  (): { name: string; url: string }[] => props.links?.[locale.value] || [],
);
</script>

<style module lang="scss">
@use '@/styles/variables' as *;

.seoLinks {
  display: flex;
  flex-wrap: wrap;

  .linkWrapper:not(:last-child)::after {
    margin: 0 $space-25;
    content: '|';

    @include caption($color-blue-70);
  }
}

.seolink {
  color: $color-blue-70;

  @include caption;
}

.separator {
  padding-inline: $space-25;
  color: $color-blue-70;

  @include caption;
}
</style>
